import { useLineMachines } from "@/features/lines/hooks";

// Spec 081 — o backend passou a fazer DUAS perguntas onde antes fazia uma
// (`production.machine-rollup.ts`), e a tela precisa fazer as mesmas duas. Uma única pergunta aqui
// significa oferecer um campo que a rota recusa (ou esconder o único caminho que sobrou), que é
// exatamente o que a fence de erro amigável existe para evitar.
//
// As duas derivam de `machine.parameters[]` já carregado por `useLineMachines` (sem fetch novo).

/**
 * "A produção é apontada por máquina" — espelha `lineHasProductionCounter` (só `PRODUCES`).
 * Nesse modo a entrada de produção no NÍVEL DA LINHA é escondida: um só escritor de `producedQty`.
 */
export function useLineTrackedByMachine(lineId: string): boolean {
  const { data: machines = [] } = useLineMachines(lineId, 30_000);
  return machines.some((m) => (m.parameters ?? []).some((p) => p.productionRole === "PRODUCES"));
}

/**
 * "O refugo é apontado por máquina" — espelha `lineHasScrapCounter` (`PRODUCES` ou `SCRAPS`), que é
 * a MESMA lista que `createLoss` aceita em `machineId`. Uma linha só de contadores de consumo
 * responde `false` nas duas pontas e continua lançando refugo no nível da linha.
 */
export function useLineScrapByMachine(lineId: string): boolean {
  const { data: machines = [] } = useLineMachines(lineId, 30_000);
  return machines.some((m) =>
    (m.parameters ?? []).some(
      (p) => p.productionRole === "PRODUCES" || p.productionRole === "SCRAPS"
    )
  );
}
